import { render } from "./i2.vue?vue&type=template&id=254bd1aa&scoped=true"
const script = {}

import "./i2.vue?vue&type=style&index=0&id=254bd1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254bd1aa"]])

export default __exports__